import {glasvordach_freitragend} from '../../../assets/images/vordaecher/data_glasvordach_freitragend';
import {glasvordach_trave} from '../../../assets/images/vordaecher/data_glasvordach_trave';
import {glasvordach_zugstaebe} from '../../../assets/images/vordaecher/data_glasvordach_zugstaebe';
import {glasvordach_pfosten} from '../../../assets/images/vordaecher/data_glasvordach_pfosten';

const initialeStates = {
    data: [glasvordach_freitragend, glasvordach_trave, glasvordach_zugstaebe, glasvordach_pfosten],
    modell_index: 0,
    allVisitedSteps: []
}

const vordaecherReducer = (states = initialeStates, action) => {
    const copyOfState = {...states};

    switch (action.type) {
        //get index of modell
        case 'UPDATEMODELLINDEXVORDAECHER':
            copyOfState.modell_index = action.ev;
        return copyOfState;

        //update width
        case 'UPDATEWIDTHVORDAECHER':
            let width = action.ev;
            copyOfState.data[copyOfState.modell_index].dimensions[0].width = width;
        return copyOfState;

        //update height
        case 'UPDATEHEIGHTVORDAECHER':
            let height = action.ev;
            copyOfState.data[copyOfState.modell_index].dimensions[0].height = height;
        return copyOfState;

        //update steps
        case 'UPDATESTEPSVORDAECHER':
            let step_index = action.ev;
            let steps = copyOfState.data[copyOfState.modell_index].steps[0];
            let visited_steps = copyOfState.data[copyOfState.modell_index].steps[1].visited;
            let step_icons = document.querySelectorAll(".MuiStepIcon-root");

            copyOfState.data[copyOfState.modell_index].steps[0][step_index] = true;
            copyOfState.data[copyOfState.modell_index].steps[1].visited[step_index] = step_index;

            steps.forEach((elem, index) => {
                 if(elem === true) {
                    step_icons[index].classList.add('MuiStepIcon-active');
                 } else {
                    step_icons[index].classList.remove('MuiStepIcon-active');
                 }
            })

            copyOfState.allVisitedSteps = visited_steps;
        return copyOfState;

        //update all visited steps
        case 'UPDATEALLVISITEDSTEPSVORDAECHER':
            copyOfState.data[copyOfState.modell_index].allVisitedSteps = true;
        return copyOfState;

         //get index of wrapper
         case 'UPDATEWRAPPERINDEXVORDAECHER':
            let wrapper_ident = action.ev.ident;
            let warpper_index = action.ev.index;

                switch (wrapper_ident) {
                    case 1:
                        copyOfState.data[copyOfState.modell_index].wrapper[0].wrapper1 = warpper_index;
                    break;
                    case 2:
                        copyOfState.data[copyOfState.modell_index].wrapper[0].wrapper2 = warpper_index;
                    break;
                    case 3:
                        copyOfState.data[copyOfState.modell_index].wrapper[0].wrapper3 = warpper_index;
                    break;
                    default:
                        return wrapper_ident;
                }

        return copyOfState;

        //update glastönung
        case 'UPDATEGLASARTVORDAECHER':
            let glastoenung = action.ev;
            copyOfState.data[copyOfState.modell_index].glasart = glastoenung;
        return copyOfState;

        //select pfosten
        case 'SELECTPFOSTENVORDAECHER':
            let pfosten = action.ev;
            copyOfState.data[3].pfosten = pfosten;
        return copyOfState;

        //select upload file
        case 'SELECTUPLOADDATAVORDAECHER':
            const fileSize = action.ev.file.size;
            const bytesToMegaBytes = fileSize / (1024 ** 2);
            if (bytesToMegaBytes>5) {
                copyOfState.data[copyOfState.modell_index].data_description[0].isUploadData = false;
            } else {
                let data_file = action.ev.file;
                copyOfState.data[copyOfState.modell_index].data_description[0].file = data_file;
                copyOfState.data[copyOfState.modell_index].data_description[0].isUploadData = true;
            }
        return copyOfState;

        //update description
        case 'UPDATEDESCRIPTIONVORDAECHER':
            let description = action.ev;
            copyOfState.data[copyOfState.modell_index].data_description[0].description = description;
        return copyOfState;

        //selct image of Category
        case 'SELECTIMAGECATEGORY':
            let imageCategory = action.ev.image;
            let imageIndex = action.ev.index;
            copyOfState.data[imageIndex].product_img = imageCategory;
        return copyOfState;

        //add products to Merkliste
        case 'UPDATEPRODUCTTOMERKLISTEVORDAECHER':
            let update_index = action.ev;
            if (update_index) copyOfState.data[update_index].is_merkliste = !copyOfState.data[update_index].is_merkliste;
            else copyOfState.data[copyOfState.modell_index].is_merkliste = !copyOfState.data[copyOfState.modell_index].is_merkliste;
        return copyOfState;

        default:
            return copyOfState;
    }
}

export default vordaecherReducer;